import React, { useEffect, useState } from 'react';

import { BINANCE_FUTTURES,GET_FUTUTERS_TOTAL_MARGIN } from '../mutations.';

import axios from 'axios';
import { useApolloClient, useMutation, useQuery } from '@apollo/client';


const BalanceData = () => {
    const [walletBalance, setWalletBalance] = useState(null);
    const [createBinanceFuture] = useMutation(BINANCE_FUTTURES);
    // const {data, error, loading} = useQuery(GET_FUTUTERS_TOTAL_MARGIN);
    const [marginBalance, setMarginBalance] = useState([])
    const client = useApolloClient(); 

    // useEffect(() => {
    //     const fetchBalance = async () => {
    //         try {
    //           const response = await axios.get('http://localhost:4000/api/futuresWalletBalance');

              
            
    //           const totalMarginBalance = parseFloat(response?.data?.totalMarginBalance);
              
    //           const timestamp = new Date().toISOString();
      
      
    //           // Store the balance in Hygraph
    //           await createBinanceFuture({ variables: { timestamp, totalMarginBalance } });
              
    //         } catch (error) {
    //           console.error('Error fetching balance:', error);
    //         }
    //       };
    //       fetchBalance();
    // }, [createBinanceFuture]);

    const fetchMarginBalance =  async ()  => {
      try {
        const response = await axios.get('http://localhost:4000/api/futuresWalletBalance');
        const totalMarginBalance = parseFloat(response?.data?.totalMarginBalance);
        const timestamp = new Date().toISOString();

        // Store the balance in Hygraph
        const result = await createBinanceFuture({ 
          variables: { timestamp, totalMarginBalance },
        });
        setMarginBalance(result.data.createBinanceFuture);
      } catch (error) {
        console.error("Error fetching balance:", error);
      }
    }
    
    useEffect(() => {
      fetchMarginBalance();

      const interval = setInterval(() => {
        fetchMarginBalance();
      }, 5000);
      return () => clearInterval();
    }, [])
    


    
  return (
    <div>
      <h1>Wallet Balance</h1>
       <p>
       Total Margin Balance: {marginBalance.totalMarginBalance} <br />
       Local Time: {marginBalance.timestamp}
       </p>
    </div>
  )
}

export default BalanceData